import {
  Form,
  Row,
  Col,
  Select,
  Button,
  Input,
  Tabs,
  Dropdown,
  Collapse,
  Card,
  Empty,
  Space,
  message
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  HistoryOutlined,
  MenuOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  UpOutlined,
  DownOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import dayjs from "dayjs";
import './index.scss'
import { CustomTable, CustomModal } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const initTableHead = {
  }

  const [tableHead, setTableHead] = useState(initTableHead);
  
  const [form] = Form.useForm();
  const [leftDocFlag, setLeftDocFlag] = useState(true);

  const [cityList, setCityList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [trustList, setTrustList] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  const [propTypeList, setPropTypeList] = useState([]);
  const [vacantUnitStatusList, setVacantUnitStatusList] = useState([]);
  const [evictionStatusList, setEvictionStatusList] = useState([]);
  const [unitTypeList, setUnitTypeList] = useState([]);
  
  const tableRequestRef = useRef(null);

  const [tabsColumns, setTabsColumns] = useState({});
  const [propsList, setPropsList] = useState([]);
  
  const [btnDisabled, setBtnDisabled] = useState(false);

  const handleDetailClick = (record) => {
    const fromPage = 'vendorClock';
    const params = {
      ...record,
      _from: fromPage,
    };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/VendorClock/Map";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const initColumns = [
    {
      title: 'Action',
      key: "action",
      dataIndex: "#",
      align: 'center',
      hidden: true,
      render: (text, record) => {
        if(['GROUP_HEADER', 'TYPE_HEADER', 'SUBTOTAL', 'GRAND_TOTAL'].includes(record?.rowType)) return '-'
        // commonFn.btnAuthorityFlag('ViewMap') && (
        return  <Dropdown
            menu={{
              items: [
                {
                  key: "view",
                  icon: <HistoryOutlined twoToneColor="#1677FF" />,
                  label: <div>View Map</div>,
                },
              ],
              // onClick: () => handleDetailClick(record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined className="col-blue" />
          </Dropdown>
        // ) || null
      },
    },
  ]


  const [refreshKey, setRefreshKey] = useState(0);
  const [tableLoading, setTableLoading] = useState(false);
  const [exporting, setExporting] = useState("");

  const TabsChildrenDoc = ({ tableList, tabKey}) => {
    return <>
      <CustomTable
        key={tabKey}
        tableLoading={tableLoading}
        columns={tabsColumns[tabKey]}
        tableList={tableList}
        pagination={false}
        rowClassName={(record) => {
          const { rowType } = record
          switch (rowType) {
            case 'GROUP_HEADER':
            case 'TYPE_HEADER':
            case 'SUBTOTAL':
            case 'GRAND_TOTAL':
              return ["VEBR700"]
            case 'DETAIL':
              return [record.vendorPaymentId]
            default:
              return [record.vendorPaymentId]
          }
        }}
        handleTableChange={handleTableChange}
        tableScrollY={leftDocFlag ? "305px" : "345px"}
        tableCss="VEBRTable"
      />
    </>
  }

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    tableRequestRef.current?.abort();
    const controller = new AbortController();
    tableRequestRef.current = controller;
    setTableLoading(true);
    try {
      const params = {
        ...tableHead,
      };
      const response = await http.post(api.vacancyEvictionBalanceShow, params, {
        signal: controller.signal,
      });
      if(controller.signal.aborted || !response) return
      if(response?.code !== "1") {
        commonFn.modalFailedFn(response)
        return
      }
      const { sections } = response.data || {}
      const tabsColumnsTemp = {}
      const propsListTemp = sections.map(item => {
        tabsColumnsTemp[item.type] = [...(item.type === 'BALANCE' ? initColumns : []), ...tabsColumnsFn(item.columns || [])]
        return {
          key: item.type,
          label: item.title,
          forceRender: false,
          tableList: item?.rows || [],
        }
      })
      setTabsColumns(tabsColumnsTemp)
      setPropsList(propsListTemp)
      return
    } catch (error) {
      if(!controller.signal.aborted) {
        message.error('Failed to load the report. Please try again.')
      }
    } finally {
      if(tableRequestRef.current === controller) {
        tableRequestRef.current = null;
        setTableLoading(false);
      }
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    return getTableListFn(pagination?.current, pagination?.pageSize, tableHead);
  };

  const tabsColumnsFn = (list) => {
    const tabsColumnsTemp = list?.map((month) => ({
      title: month?.title,
      dataIndex: month?.field,
      key: month?.field,
      // width: month?.label?.includes(' - ') ? 200 : 100,
      onCell: (record) => ({
        className: ['GROUP_HEADER', 'TYPE_HEADER', 'SUBTOTAL', 'GRAND_TOTAL'].includes(record.rowType) && String(record[month.field] ?? '').trim() ? 'VEBR_underline' : '',
      }),
      render: (text) => {
        switch (month?.dataType) {
          case 'STRING':
          case 'INTEGER':
            return text
          case 'MONEY':
           return commonFn.amountToDollarFn(text)
          case 'DATE':
           return text
          case 'PERCENT':
           return text ? `${text}%` : text 
          default:
            return text
        }
      },
    }));
    return tabsColumnsTemp
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setTabsColumns({});
  }

  useEffect(() => {
    initColunmsFn()
  }, [refreshKey])

  const tabItems = propsList.map(item => ({
    key: item.key,
    label: item.label,
    forceRender: item.forceRender,
    children: (
      <TabsChildrenDoc
        key={item.key}
        tableList={item.tableList}
        tabKey={item.key}
      />
    ),
  }));

  const getCurrentDate = async(mode, key) => {
    const response = await http.get(api.getDateRange, {params: {mode}})
    if(response?.code === "1"){
      form.setFieldsValue({
        [key]: response.data,
      });
    } else {
      commonFn.modalFailedFn(response);
    }
  }

  const getCityList = async () => {
    const response = await http.get(api.getCityDictByProperty);
    setCityList(response?.data || []);
  };

  const getGroupList = async () => {
    const response = await http.get(api.commonGroupList);
    setGroupList(response.data || []);
  };

  const getTrustIdList = async () => {
    const response = await http.get(api.getTrustDictList);
    setTrustList(response?.data || []);
  };

  const getOwnerIdList = async () => {
    const response = await http.get(api.getOwnerDictList);
    setOwnerList(response?.data || []);
  };

  const getPropTypeList = async () => {
    const response = await http.get(api.getPropTypeList);
    setPropTypeList(response?.data || []);
  };

  const getVacantUnitStatusList = async () => {
    const response = await http.get(api.vacancyEvictionBalanceVacantUnitStatus);
    setVacantUnitStatusList(response?.data || []);
  };

  const getEvictionStatusList = async () => {
    const response = await http.get(api.vacancyEvictionBalanceEvictionStatus);
    setEvictionStatusList(response?.data || []);
  };

  const getUnitTypeList = async () => {
    const response = await http.get(api.getUnitTypeList);
    setUnitTypeList(response?.data || []);
  };

  useEffect(() => {
    getCurrentDate('sixMonths', '6MonthsRange')
    getCurrentDate('currentMonth', 'PaymentDateRange')

    getCityList()
    getGroupList()
    getTrustIdList()
    getOwnerIdList()
    getPropTypeList()
    getVacantUnitStatusList()
    getEvictionStatusList()
    getUnitTypeList()
  }, []);

  useEffect(() => {
    return () => tableRequestRef.current?.abort()
  }, [])

  const formatDateRange = (dateRange = []) => dateRange.map(item => item.format('YYYY-MM-DD'))
  
  const submitFn = async() => {
    form.validateFields().then(value => {
      const params = {
        ...value,
      }
      setTableHead(params)
      getTableListFn(1, 20, params)
    }).catch(err =>{
      console.log(err,'===err');
    })
  }

  const exportFn = async(format) => {
    setExporting(format)
    try {
      const value = await form.validateFields()
      const params = {
        ...value,
      }
      const endpoint = format === 'pdf' ? api.vacancyEvictionBalanceExportPDF : api.vacancyEvictionBalanceExportCSV
      const blob = await http.post(endpoint, params, { responseType: 'blob' })
      if (!(blob instanceof Blob)) throw new Error('Invalid file response')
      if (blob.type.includes('application/json')) {
        throw new Error((JSON.parse(await blob.text()))?.msg || 'Export failed.')
      }
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `Operating_Statement_${dayjs().format('YYYYMMDD_HHmmss')}.${format}`
      link.click()
      window.setTimeout(() => window.URL.revokeObjectURL(url), 1000)
    } catch (error) {
      if (!error?.errorFields) message.error(error?.message || 'Export failed.')
    } finally {
      setExporting("")
    }
  }

  const ReportFormDoc = () => {
    return <>
      <Form
        form={form}
        layout="vertical"
        labelWrap={true}
        labelAlign="right"
        initialValues={{
          // common
          prop: '0001-ZZZZ',
          // balanceReport
          balanceDisplayBy: 'group_code',
          sort1: 'move_in_date',
          amount: '0.01',
          status: 'Current',
          // Vacancy, Eviction
          vacancyGroupBy: 'city',
          vacancyTypeGroupBy: 'propertyType',
          vacancySort: 'prop',
          vacantUnitStatus: ['ex_no_show'],
          evictionGroupBy: 'city',
          evictionTypeGroupBy: 'propertyType',
          evictionSort: 'prop',
          evictionStatusList: ['']
        }}
        validateMessages={{
          required: "${label} is required!",
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            {/* common====== */}
            <Form.Item
              name="prop"
              label="Prop"
              rules={[{ required: true, message: 'Prop is required!' }]}
            >
              <Input.TextArea
                placeholder="Please input Prop"
                autoSize={{ minRows: 3, maxRows: 10 }}
              />
            </Form.Item>

            <Form.Item label="City" name="cityList">
              <Select
                showSearch
                allowClear
                mode="multiple"
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  label: 'label',
                  value: 'value',
                }}
                options={cityList}
              />
            </Form.Item>

            <Form.Item label="Group" name="groupIdList">
              <Select
                showSearch
                allowClear
                mode="multiple"
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.geographyGroup ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  label: 'geographyGroup',
                  value: 'groupId',
                }}
                options={groupList}
              />
            </Form.Item>

            <Form.Item label="Trust" name="trustIdList">
              <Select
                showSearch
                allowClear
                mode="multiple"
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.trustNameTitle ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  label: 'trustNameTitle',
                  value: 'trustId',
                }}
                options={trustList}
              />
            </Form.Item>

            <Form.Item label="Owner" name="ownerIdList">
              <Select
                showSearch
                allowClear
                mode="multiple"
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.titleName ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  label: 'titleName',
                  value: 'ownerId',
                }}
                options={ownerList}
              />
            </Form.Item>

            <Form.Item label="Property Type" name="propTypeList">
              <Select
                showSearch
                allowClear
                mode="multiple"
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.name ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  label: 'name',
                  value: 'code',
                }}
                options={propTypeList}
              />
            </Form.Item>

            <Form.Item
              label="Print By"
              name="printBy"
            >
              <Select
                allowClear
                placeholder="Select a type"
                options={[
                  { label: "Print By Group By", value: "groupBy" },
                ]}
              />
            </Form.Item>
          {/* balanceReport====== */}
            <Form.Item
              label="Display By"
              name="balanceDisplayBy"
              rules={[{ required: true, message: 'Display By is required!' }]}
            >
              <Select
                allowClear
                placeholder="Select a type"
                options={[
                  { label: "Group", value: "group_code" },
                  { label: "Property", value: "prop" },
                  { label: "Supervisor", value: "supervisor" },
                  { label: "City", value: "city" },
                  { label: "Manager", value: "line2" },
                ]}
              />
            </Form.Item>

            <Form.Item 
             name="6MonthsRange" 
             label="6 Months Range"
             rules={[{ required: true, message: '6 Months Range is required!' }]}
            >
              <Input
                disabled
                placeholder="Please input 6 Months Range"
              />
            </Form.Item>

            <Form.Item 
             name="PaymentDateRange" 
             label="Payment Date Range"
             rules={[{ required: true, message: 'Payment Date Range is required!' }]}
            >
              <Input
                disabled
                placeholder="Please input Payment Date Range"
              />
            </Form.Item>

            {commonFn.formInputNumberDoc({
              form,
              name: "amount",
              label: "Ending Balance >=",
              allowNegative: true,
              validator: (_, value, callback) => {
                callback()
              }
            })}

            <Form.Item
              label="Spec Code"
              name="spec_code"
            >
              <Select
                allowClear
                placeholder="Select a type"
                options={[
                  { label: "Rent", value: "R" },
                  { label: "Late", value: "L" },
                  { label: "Eviction", value: "E" },
                  { label: "30 day notice", value: "T" },
                  { label: "Pending vacant", value: "U" },
                  { label: "Payment plan", value: "P" },
                  { label: "Other", value: "O" },
                  { label: "Eviction & Rent", value: "B" },
                ]}
              />
            </Form.Item>

            <Form.Item
              label="Rent Assist"
              name="tenant_type"
            >
              <Select
                allowClear
                placeholder="Select a type"
                options={[
                  { label: "No", value: "0" },
                  { label: "Yes", value: "1" },
                ]}
              />
            </Form.Item>

            <Form.Item 
             name="status" 
             label="Status"
             rules={[{ required: true, message: 'Status is required!' }]}
            >
              <Input
                disabled
                placeholder="Please input Status"
              />
            </Form.Item>

            <Form.Item
              label="Sort"
              name="sort1"
              rules={[{ required: true, message: 'Sort is required!' }]}
            >
              <Select
                allowClear
                placeholder="Select a type"
                options={[
                  { label: "Property", value: "prop" },
                  { label: "Move In Date", value: "move_in_date" },
                  { label: "Property Type", value: "prop_type" },
                  { label: "Unit Type", value: "unit_type" },
                  { label: "City", value: "city" },
                  { label: "Manager", value: "line2" },
                ]}
              />
            </Form.Item>

            {/* Vacancy, Eviction===== */}
            <Form.Item
              label="Vacancy Group By"
              name="vacancyGroupBy"
              rules={[{ required: true, message: 'Vacancy Group By is required!' }]}
            >
              <Select
                allowClear
                placeholder="Select a type"
                options={[
                  { label: "City", value: "city" },
                  { label: "Group", value: "group_code" },
                  { label: "Month", value: "month" },
                  { label: "Supervisor", value: "supervisor" },
                  { label: "Landlord Attorney", value: "attorney" },
                ]}
              />
            </Form.Item>

            <Form.Item
              label="Vacancy Type Group By"
              name="vacancyTypeGroupBy"
            >
              <Select
                allowClear
                placeholder="Select a type"
                options={[
                  { label: "Property Type", value: "propertyType" },
                  { label: "Unit Type", value: "unitType" },
                ]}
              />
            </Form.Item>

            <Form.Item
              label="Vacancy Sort"
              name="vacancySort"
              rules={[{ required: true, message: 'Vacancy Sort is required!' }]}
            >
              <Select
                allowClear
                placeholder="Select a type"
                options={[
                  { label: "Prop", value: "prop" },
                  { label: "Vacancy Date", value: "move_out_date" },
                ]}
              />
            </Form.Item>

            <Form.Item label="Vacant Unit Status" name="vacantUnitStatus">
              <Select
                showSearch
                allowClear
                mode="multiple"
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  label: 'label',
                  value: 'value',
                }}
                options={vacantUnitStatusList}
              />
            </Form.Item>

            <Form.Item
              label="Eviction Group By"
              name="evictionGroupBy"
              rules={[{ required: true, message: 'Eviction Group By is required!' }]}
            >
              <Select
                allowClear
                placeholder="Select a type"
                options={[
                  { label: "City", value: "city" },
                  { label: "Group", value: "group_code" },
                  { label: "Month", value: "month" },
                  { label: "Supervisor", value: "supervisor" },
                  { label: "Landlord Attorney", value: "attorney" },
                ]}
              />
            </Form.Item>

            <Form.Item
              label="Eviction Type Group By"
              name="evictionTypeGroupBy"
            >
              <Select
                allowClear
                placeholder="Select a type"
                options={[
                  { label: "Property Type", value: "propertyType" },
                  { label: "Unit Type", value: "unitType" },
                ]}
              />
            </Form.Item>

            <Form.Item
              label="Eviction Sort"
              name="evictionSort"
              rules={[{ required: true, message: 'Eviction Sort is required!' }]}
            >
              <Select
                allowClear
                placeholder="Select a type"
                options={[
                  { label: "Property", value: "prop" },
                  { label: "Eviction Date", value: "date" },
                  { label: "Status", value: "statusEvent" },
                  { label: "Status Date", value: "statusDate" },
                ]}
              />
            </Form.Item>

            <Form.Item label="Eviction Status" name="evictionStatusList">
              <Select
                showSearch
                allowClear
                mode="multiple"
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  label: 'label',
                  value: 'value',
                }}
                options={evictionStatusList}
              />
            </Form.Item>

            <Form.Item label="Unit Type" name="evictionUnitTypeList">
              <Select
                showSearch
                allowClear
                mode="multiple"
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  label: 'label',
                  value: 'value',
                }}
                options={unitTypeList}
              />
            </Form.Item>

          </Col>
        </Row>
      </Form>
      <div style={{textAlign:'center'}}>
        <Button type="primary" style={{ width: '100%'}} onClick={() => submitFn()} loading={tableLoading} disabled={btnDisabled}>
          Submit
        </Button>
      </div>    
    </>
  }

  return (
    <div className={`VacancyEvictionBalanceReport pageMaxWidth`}>
      {leftDocFlag && <Card
        className="VEBRLeft"
        title={(
          <div className="VEBRFilterHeader">
            <span>Report filters</span>
            <Button
              className="VEBRCollapse"
              type="text"
              icon={<UpOutlined />}
              onClick={() => setLeftDocFlag(false)}
            >
              Hide filters
            </Button>
          </div>
        )}
      >
        <Collapse items={[
          {
            key: '1',
            label: 'Report Form',
            children: ReportFormDoc(),
          },
        ]} defaultActiveKey={['1']} accordion />
      </Card>}

      <div className="VEBRRight">
        {!leftDocFlag && <div className="VEBRShowFilters">
          <Button
            className="VEBRCollapse"
            type="text"
            icon={<DownOutlined />}
            onClick={() => setLeftDocFlag(true)}
          >
            Show filters
          </Button>
        </div>}
        <Card
          className="VEBRResultCard"
          title={(
            <div className="VEBRTitle">
              <span className="VEBRReportMark"><FileTextOutlined /></span>
              <div className="VEBRTitleLabel">Vacancy, Eviction & Balance Report</div>
            </div>
          )}
          extra={(
            <Space>
              <commonFn.BtnAuthorityFn authKey={"ExportCSV"}>
                <Button icon={<FileTextOutlined />} loading={exporting === "csv"} onClick={() => exportFn("csv")}>CSV</Button>
              </commonFn.BtnAuthorityFn>
              <commonFn.BtnAuthorityFn authKey={"ExportPDF"}>
                <Button type="primary" icon={<FilePdfOutlined />} loading={exporting === "pdf"} onClick={() => exportFn("pdf")}>PDF</Button>
              </commonFn.BtnAuthorityFn>
            </Space>
          )}
        >
          <div className="VEBRMain">
            <div className="VEBRPropList">
              {tabItems.length ? <Tabs
                className="VEBRTabs"
                items={tabItems}
                // animated
                destroyInactiveTabPane
                more={{
                  trigger: 'click',
                  placement: 'bottomLeft',
                }}
              /> : <Empty
                className="VEBREmpty"
                description="Run the report to review data."
              />}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
});
export default MainTable;
